import { render } from "./menuBar.vue?vue&type=template&id=d6fab166&scoped=true"
import script from "./menuBar.vue?vue&type=script&lang=js"
export * from "./menuBar.vue?vue&type=script&lang=js"

import "./menuBar.vue?vue&type=style&index=0&id=d6fab166&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6fab166"]])

export default __exports__